<template>
	<div>
		<div id="main-wrapper">
			<!-- Static header for specific routes (error pages, etc) -->
			<StaticHeader v-if="staticHeaderList.includes($route.name)" />
			<LandingpageHeader
				id="hideinmobile"
				v-else-if="$route.name == 'Homepage'"
			/>

			<!-- Authenticated header -->
			<Header v-else-if="isAuthenticated || isPublicProfile" />

			<!-- Guest header for non-authenticated users -->
			<GuestHeader v-else />

			<NoSideBarMain />
		</div>
	</div>
</template>

<script>
import LandingpageHeader from "@/components/LandingPage/LandingpageHeader.vue";
import GuestHeader from "@/components/fixedcomponents/GuestHeader.vue";
import Header from "@/components/fixedcomponents/header.vue";
import NoSideBarMain from "@/components/Layout/NoSideBarMain";
import StaticHeader from "@/components/fixedcomponents/staticHeader.vue";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/tokenCheck.js";

export default {
	name: "LayoutNoSidebar",
	components: {
		Header,
		GuestHeader,
		NoSideBarMain,
		StaticHeader,
		LandingpageHeader,
	},

	data() {
		return {
			staticHeaderList: ["PageNotFound", "IdCapture"],
		};
	},
	created() {
		console.log("in herererrere");
	},
	computed: {
		...mapGetters("userVUEX", {
			vuexToken: "getToken",
		}),
		isAuthenticated() {
			// Check if user has a valid token reactively
			return !!(this.vuexToken || getToken());
		},
		isPublicProfile() {
			return this.$route.name === "ViewPublicProfile";
		},
	},
};
</script>

<style></style>
